import React, { PureComponent } from 'react';

export default class FoodProfileMobileSidebarHandler extends PureComponent {
  render() {
    if (!this.props.isFoodMaestroEnabled) return null;

    return (
      <button
        className="btn-tertiary hide-for-xlarge foodProfileMobileSidebarHandler"
        onClick={this.props.showFoodProfileMobileSidebar}
      >
        Food Profile
      </button>
    );
  }
}
